import Settings from ".";

export const settingsRoutes = () => [
  {
    path: "/admin/setting",
    title: "settings",
    layout: "admin",
    routeType: "admin",
    component: Settings,
  },
];